import React from 'react';

interface FormFieldProps {
  type?: 'text' | 'email' | 'tel' | 'number';
  id?: string;
  name: string;
  value: string;
  placeholder?: string;
  error?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  required?: boolean;
  autoComplete?: string;
  min?: number;
  max?: number;
  step?: number | 'any';
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
}

export const FormField: React.FC<FormFieldProps> = ({
  type = 'text',
  id,
  name,
  value,
  placeholder,
  error,
  onChange,
  onBlur,
  required,
  autoComplete,
  min,
  max,
  step,
  inputMode
}) => {
  const fieldId = id ?? name;
  const errorId = error ? `error-${fieldId}` : undefined;

  return (
    <>
      <input
        id={fieldId}
        type={type}
        className={`input-field ${error ? 'error' : ''}`}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        autoComplete={autoComplete}
        aria-describedby={errorId}
        aria-invalid={!!error}
        min={min}
        max={max}
        step={step}
        inputMode={inputMode}
      />
      {error && (
        <span id={errorId} className="error-message error-text">
          {error}
        </span>
      )}
    </>
  );
};

